import React from 'react';

import TableHeader, { type Props as TableHeaderProps } from '@dashboard/components/table/TableHeader';
import { useSetCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { Chip, Link, Stack, Typography } from '@mui/material';

import CreateTopicListDialog from './CreateTopicListDialog';
import useCurrentGroups from './useCurrentGroups';

export default function PageHeader() {
  const { data } = useCurrentGroups();
  const setPage = useSetCurrentPage();
  const props: TableHeaderProps = {
    setPage,
    title: (
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Typography variant="h4">Unsubscribe groups</Typography>
        <Link target="_blank" href="https://www.usewaypoint.com/docs/unsubscribe-groups">
          <Chip label="BETA" size="small" sx={{ cursor: 'pointer' }} />
        </Link>
      </Stack>
    ),
    actions: <CreateTopicListDialog />,
  };

  const model = data?.ContactsGroups;
  if (model === undefined) {
    return <TableHeader {...props} />;
  }

  const count = model.count;
  const limit = model.meta.limit;
  const currentPage = model.meta.page;
  return <TableHeader currentPage={currentPage} limit={limit} count={count} {...props} />;
}
